import { useEffect, useState } from 'react';
import Config from 'config/config';

export default function CloudflareValidate(props: { elementId?: string, tokenResponseHandle : (token: string) => void, resetFlag : number}){

    const {elementId = 'cf-validate', tokenResponseHandle } = props ;
    const [ widgetId, setWidgetId ] = useState<string>();

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback'; // 替换为你的JS文件链接
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);

        // @ts-expect-error: cloudflare
        window.onloadTurnstileCallback = () => {
            setWidgetId((id: string | undefined) => {
                if(!id){
                    // @ts-expect-error: cloudflare
                    const newWidgetId = window.turnstile.render("#" + elementId, {
                        sitekey: Config.cloudflareSiteKey,
                        callback: function (token: string) {
                            tokenResponseHandle(token)
                        }
                    });
                    return newWidgetId;
                }
                return id ;
            });
        }
        return () => {
            document.body.removeChild(script);
        };
    },[])

    useEffect(() => {
        if(props.resetFlag && widgetId){
            // @ts-expect-error: cloudflare
            window.turnstile.reset(widgetId)
        }
    }, [props.resetFlag, widgetId])

    return (
        <>
        </>
    )
}